import React, { useState } from "react";
import { Box, Tab, Tabs, Divider } from "@mui/material";
import SupplierGRN from "./SupplierGRN";
import ReturnedAccessoriesGRNTab from "./ReturnedAccessoriesGRNTab";
import { MecordColors } from "Constants/Color";

type GRNProps = {
  warehouseId: string;
};

const WarehouseGRN: React.FC<GRNProps> = ({ warehouseId }) => {
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = sessionStorage.getItem("WarehouseGRNChildTab");
    return savedTab ? parseInt(savedTab, 10) : 0;
  });

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    sessionStorage.setItem("WarehouseGRNChildTab", newValue.toString());
  };

  return (
    <div
      className="d-flex flex-column"
      style={{ flex: "1 1 auto", minHeight: 0, maxHeight: "100%", overflow: "hidden" }}
    >
      <Box
        sx={{
          mt: 1,
          mb: 1,
          px: 2,
          pt: 1,
          pb: 0,
          bgcolor: "#fafafa",
          borderRadius: "8px",
          border: "1px solid #ebebeb",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="mecord-tabs-wrap">
          <Box sx={{ width: "100%", mb: 0 }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              sx={{
                minHeight: 30,
                "& .MuiTab-root": {
                  fontFamily: "'Poppins', sans-serif",
                  textTransform: "none",
                  color: "#555555",
                  minHeight: 30,
                  paddingTop: "2px",
                  paddingBottom: "2px",
                  transition: "color 0.2s ease",
                },
                "& .MuiTab-root:hover": {
                  color: "#d2363a",
                },
                "& .Mui-selected": {
                  color: "#d2363a !important",
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "#d2363a",
                  height: "3px",
                  transition: "all 0.3s ease",
                },
              }}
            >
              <Tab label="Supplier GRN" />
              <Tab label="Returned Accessories GRN" />
            </Tabs>
            <Divider sx={{ mt: 0, borderColor: "#c35f61" }} />
          </Box>
        </div>
      </Box>

      <div
        style={{
          flex: "1 1 auto",
          minHeight: 0,
          maxHeight: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {activeTab === 0 ? (
          <SupplierGRN key={`supplier-grn-${warehouseId}`} warehouseId={warehouseId} />
        ) : activeTab === 1 ? (
          <ReturnedAccessoriesGRNTab key={`ret-acc-grn-${warehouseId}`} warehouseId={warehouseId} />
        ) : null}
      </div>
    </div>
  );
};

export default WarehouseGRN;
